module.exports = __webpack_public_path__ + "media/images/title_mobile@3x-6e4aab8d5c7ab963e74f4c7c157efadb.png";